import React from "react";
import { Form, Input, Space } from "antd";
import StepHeader from "../../../Evaluation/StepHeader";

const { TextArea } = Input;

interface DatasetNameProps {
  name?: string;
  description?: string;
  onChange: (name: string, description: string) => void;
}

const DatasetName: React.FC<DatasetNameProps> = ({
  name,
  description,
  onChange,
}) => {
  return (
    <Space 
      direction="vertical" 
      size="large" 
      style={{ 
        width: "100%",
        display: "flex",
        alignItems: "center"
      }}
    >
      <StepHeader
        title="Dataset Details"
        description="Enter a name and description for your dataset"
        style={{ textAlign: "center" }}
      />
      
      <Form layout="vertical" style={{ width: "500px" }}>
        <Form.Item
          label="Name"
          required
          tooltip="A unique name for your dataset"
        >
          <Input
            size="large"
            value={name}
            onChange={(e) => onChange(e.target.value, description || "")}
            placeholder="Enter dataset name"
          />
        </Form.Item>

        <Form.Item
          label="Description"
          tooltip="Provide a brief description of this dataset"
        >
          <TextArea
            rows={4}
            value={description}
            onChange={(e) => onChange(name || "", e.target.value)}
            placeholder="Enter dataset description"
          />
        </Form.Item>
      </Form>
    </Space>
  );
};

export default DatasetName; 